import {theme} from "antd";

const sharedButtonTokens = {
  colorPrimary: "#FFE600",
  primarycolor: "var(--theme-text-on-primary)",
  defaultBg: "transparent",
  defaultHoverBg: "#1E232B",
  defaultcolor: "var(--theme-text-on-primary)",
  defaultActivecolor: "var(--theme-text-on-primary)",
  defaultHovercolor: "var(--theme-text-on-primary)",
  colorPrimaryHover: "#FFE600",
};

const sharedMenuTokens = {
  lineHeight: 21,
  fontSize: 18,
  fontWeight: 400,
  iconMarginInlineEnd: 22,
  itemBg: "transparent",
  algorithm: true,
  itemHoverColor: "#FFE600",
  itemMarginInline: 15,
  itemHeight: 55,
  itemBorderRadius: 15,
  subMenuItemBorderRadius: 15,
};

export const getDarkAntdTheme = () => ({
  cssVar: true,
  algorithm: theme.darkAlgorithm,
  token: {
    colorPrimary: "#FFE600",
    colorBgContainer: "#0F1115",
    colorPrimaryBg: "#0F1115",
    colorTextHeading: "var(--text-primary)",
    colorText: "var(--text-primary)",
    colorBgElevated: "#161A21",
  },
  components: {
    Button: sharedButtonTokens,
    Layout: {
      headerBg: "#0B0E13",
      siderBg: "#0F1115",
      headerHeight: "100px",
      bodyBg: "#161A21",
      algorithm: true,
    },
    Menu: {
      ...sharedMenuTokens,
      popupBg: "#0F1115",
      darkItemBg: "transparent",
      darkSubMenuItemBg: "#0F1115",
      darkPopupBg: "#0F1115",
      darkItemColor: "var(--text-primary)",
      darkItemSelectedBg: "#161A21",
      darkItemHoverBg: "#161A21",
      itemColor: "var(--text-primary)",
      darkItemHoverColor: "#FFE600",
      darkItemSelectedColor: "#FFE600",
    },
    Content: {algorithm: true},
    Modal: {
      algorithm: true,
      contentBg: "#0F1115",
      headerBg: "#0F1115",
      titleColor: "var(--text-primary)",
      colorIcon: "#CCCCCC",
      colorIconHover: "var(--text-primary)",
    },
    Form: {labelColor: "var(--text-primary)"},
    Input: {
      colorTextPlaceholder: "var(--text-primary)",
      activeBg: "#161A21",
    },
    Select: {
      optionActiveBg: "#161A21",
      selectorBg: "#0F1115",
      optionSelectedBg: "#161A21",
      optionSelectedColor: "#FFE600",
      optionActiveColor: "#FFE600",
    },
  },
});

export const getLightAntdTheme = () => ({
  cssVar: true,
  algorithm: theme.defaultAlgorithm,
  token: {
    colorPrimary: "#FFE600",
    colorBgContainer: "#FFFFFF",
    colorPrimaryBg: "#f0f2f5",
    colorTextHeading: "#111827",
    colorText: "#374151",
    colorBgElevated: "#FFFFFF",
    colorBgLayout: "#f0f2f5",
  },
  components: {
    Button: sharedButtonTokens,
    Layout: {
      headerBg: "#FFFFFF",
      siderBg: "#FFFFFF",
      headerHeight: "100px",
      bodyBg: "#f0f2f5",
      algorithm: true,
    },
    Menu: {
      ...sharedMenuTokens,
      popupBg: "#FFFFFF",
      darkItemBg: "transparent",
      darkSubMenuItemBg: "#f0f2f5",
      darkPopupBg: "#f0f2f5",
      darkItemColor: "#374151",
      darkItemSelectedBg: "#eef0f4",
      darkItemHoverBg: "#eef0f4",
      itemColor: "#374151",
      darkItemHoverColor: "#FFE600",
      darkItemSelectedColor: "#FFE600",
    },
    Content: {algorithm: true},
    Modal: {
      algorithm: true,
      contentBg: "#FFFFFF",
      headerBg: "#FFFFFF",
      titleColor: "#111827",
      colorIcon: "#6b7280",
      colorIconHover: "#111827",
    },
    Form: {labelColor: "#374151"},
    Input: {
      colorTextPlaceholder: "#9ca3af",
      activeBg: "#f3f4f6",
    },
    Select: {
      optionActiveBg: "#f3f4f6",
      selectorBg: "#f3f4f6",
      optionSelectedBg: "#eef0f4",
      optionSelectedColor: "#FFE600",
      optionActiveColor: "#FFE600",
    },
  },
});

export const rygTheme = getDarkAntdTheme();
